import styled, { css } from 'styled-components';
import { ListVariant } from '../../../_shared/types/trade';
import { BidStatus } from '../../../_shared/types/auction';

const StyledInvalidTradeCardVariants = {
  [BidStatus.topBidder]: css`
    max-width: 876px;
  `,
  [BidStatus.outbid]: css`
    max-width: 876px;
  `,
  [BidStatus.proxy]: css`
    max-width: 882px;
  `,
  [BidStatus.none]: css`
    max-width: 882px;
  `
};

const StyledInvalidTradeCardSaleEventVariants = {
  [BidStatus.topBidder]: css`
    max-width: 855px;
  `,
  [BidStatus.outbid]: css`
    max-width: 855px;
  `,
  [BidStatus.proxy]: css`
    max-width: 862px;
  `,
  [BidStatus.none]: css`
    max-width: 862px;
  `
};

export const StyledInvalidTradeCard = styled.div`
  width: 100%;
  height: 204px;
  position: absolute;
  background: ${({ theme }) => theme.COLORS.BASE};
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  opacity: 0.5;
  z-index: 26;

  ${props =>
    props.isInSaleEvent
      ? StyledInvalidTradeCardSaleEventVariants[props.variant]
      : StyledInvalidTradeCardVariants[props.variant]}
`;

const StyledThumbnailVariants = {
  [ListVariant.LIST]: css`
    margin: 0;
    border-start-start-radius: 3px;
    border-end-start-radius: 3px;
  `,
  [ListVariant.SEARCH]: css`
    margin-top: 12px;
    border-radius: 3px;
  `
};

export const StyledThumbnail = styled.div`
  cursor: pointer;
  position: relative;
  display: flex;
  flex: 0 0 auto;
  margin-left: 12px;
  margin-bottom: 12px;
  width: 240px;
  height: 204px;
  background: url(${props => (props.url ? props.url : 'none')}) no-repeat;
  background-position: top;
  background-size: cover;
  background-color: ${({ theme }) => theme.COLORS.NEUTRAL_50};

  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};

  &:hover,
  &:active,
  &:focus,
  &:visited {
    color: inherit;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  ${({ variant }) => StyledThumbnailVariants[variant]}
`;
